import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import fi from "./fi.json";
import fr from "./fr.json";
import it from "./it.json";
import pt from "./pt.json";

export const resources = {
  de: { translation: de },
  en: { translation: en },
  es: { translation: es },
  fi: { translation: fi },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt }
};
